import React, { Component } from 'react';
import { bool, func, number, string } from 'prop-types';
import BuildMinMaxByDropdown from './BuildMinMaxByDropdown';
import PercentageOfMid from './PercentageOfMid';
import TargetRangeSpreadSetting from './TargetRangeSpreadSetting';
import { BUILD_BY_PERCENTAGE, BUILD_BY_TARGET } from '../../Utils/constants';

class BuildMinMaxBy extends Component {
  static propTypes = {
    buildMinMaxBy: string,
    handleMaxPercentChange: func,
    handleMinPercentChange: func,
    handleRangeSpreadChange: func.isRequired,
    isGlobal: bool,
    maxPercentageMarketElement: string,
    maxPercentageOfMid: number,
    minPercentageMarketElement: string,
    minPercentageOfMid: number,
    proposedMaxSelect: func,
    proposedMinSelect: func,
    rangeType: string,
    saveBuildMinMaxBy: func,
    targetRangeSpread: number
  };

  static defaultProps = {
    isGlobal: false
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {
      buildMinMaxBy,
      handleMaxPercentChange,
      handleMinPercentChange,
      handleRangeSpreadChange,
      isGlobal,
      maxPercentageMarketElement,
      maxPercentageOfMid,
      minPercentageMarketElement,
      minPercentageOfMid,
      proposedMaxSelect,
      proposedMinSelect,
      rangeType,
      saveBuildMinMaxBy,
      setProposedRangeOptions,
      targetRangeSpread
    } = this.props;

    return (
      <div className="stat__group">
        {isGlobal && (
          <BuildMinMaxByDropdown
            buildMinMaxBy={buildMinMaxBy}
            isGlobal={isGlobal}
            rangeType={rangeType}
            saveBuildMinMaxBy={saveBuildMinMaxBy}
          />
        )}
        {buildMinMaxBy === BUILD_BY_TARGET && (
          <TargetRangeSpreadSetting
            handleRangeSpreadChange={handleRangeSpreadChange}
            isGlobal={isGlobal}
            targetRangeSpread={targetRangeSpread}
          />
        )}
        {buildMinMaxBy === BUILD_BY_PERCENTAGE && (
          <PercentageOfMid
            handleMaxPercentChange={handleMaxPercentChange}
            handleMinPercentChange={handleMinPercentChange}
            isGlobal={isGlobal}
            maxPercentageMarketElement={maxPercentageMarketElement}
            maxPercentageOfMid={maxPercentageOfMid}
            minPercentageMarketElement={minPercentageMarketElement}
            minPercentageOfMid={minPercentageOfMid}
            proposedMaxSelect={proposedMaxSelect}
            proposedMinSelect={proposedMinSelect}
            rangeType={rangeType}
            setProposedRangeOptions={setProposedRangeOptions}
          />
        )}
      </div>
    );
  }
}

export default BuildMinMaxBy;
